var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskAltOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 22a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12q0-2.075.788-3.9a10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2q1.2 0 2.338.275 1.137.275 2.187.8.375.2.488.6a.84.84 0 0 1-.138.75 1.1 1.1 0 0 1-.663.45 1.16 1.16 0 0 1-.812-.1 8.4 8.4 0 0 0-1.662-.575A7.7 7.7 0 0 0 12 4Q8.675 4 6.338 6.338 4 8.675 4 12t2.338 5.663T12 20t5.663-2.337T20 12a6 6 0 0 0-.05-.775 1.33 1.33 0 0 1 .163-.812q.212-.389.637-.513a.9.9 0 0 1 .75.075.77.77 0 0 1 .4.6A10 10 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137A9.7 9.7 0 0 1 12 22m-1.4-8.2 9.3-9.325a.98.98 0 0 1 .688-.287.93.93 0 0 1 .712.287.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7L11.3 15.9q-.3.3-.7.3a.96.96 0 0 1-.7-.3l-2.85-2.85a.95.95 0 0 1-.275-.7q0-.425.275-.7a.95.95 0 0 1 .7-.275q.425 0 .7.275z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAltOutline);
export default __webpack_public_path__ + "static/media/task_alt_outline.36b3a19bd9143df748d93edff8dd1174.svg";
export { ForwardRef as ReactComponent };